import { business } from "../client";
import {
  buildEntityPayload,
  buildMutationEntityPayload,
  buildPaginatedEntityPayload,
  buildSearchEntityPayload,
  buildSignalConfig,
} from "../utils/entityRequests";

const BUSINESS_MUTATION_FIELDS = {
  expectedRevision: "expectedRevision",
  idClient: "idClient",
  name: "name",
  address: "address",
  websiteUrl: "websiteUrl",
  phone: "phone",
  status: "status",
  apiType: "apiType",
  avvioPassword: "avvioPassword",
  avvioUsername: "avvioUsername",
  mewsClientId: "mewsClientId",
  hotelEmail: "hotelEmail",
  assistantId: "assistantId",
  greetingMessage: "greetingMessage",
  accessToken: "accessToken",
  clientToken: "clientToken",
  hotelRedirectUrl: "hotelRedirectUrl",
  open_by_default: "open_by_default",
  openButtonStyle: "openButtonStyle",
  instagramDm: "instagramDM",
  instagramAccessToken: "instagramAccessToken",
  whatsAppDm: "whatsAppDm",
  whatsAppAccessToken: "whatsAppAccessToken",
  rivet: "rivet",
  system_prompt: "system_prompt",
  functions_json: "functions_json",
  rivet_yaml: "rivet_yaml",
  greeting_buttons_enabled: "greeting_buttons_enabled",
  greeting_buttons: "greeting_buttons",
  themeOn: "themeOn",
  themeLogo: "themeLogo",
  themePrimaryColor: "themePrimaryColor",
  themeFont: "themeFont",
  themeOpenButtonBottomCss: "themeOpenButtonBottomCss",
  standard_ai_functions: "standard_ai_functions",
  link_buttons_enabled: "link_buttons_enabled",
  link_buttons: "link_buttons",
};

export const getBusiness = (params) => {
  return business.post("/query", buildPaginatedEntityPayload("business", params));
};

export const searchBusiness = (params) => {
  return business.post(
    "/search",
    buildSearchEntityPayload("business", params),
    buildSignalConfig(params)
  );
};

export const searchBusinessByClient = (params) => {
  return business.post(
    "/details/search",
    buildSearchEntityPayload("business", params, {
      clientId: params?.clientId,
    }),
    buildSignalConfig(params)
  );
};

export const addBusiness = (params) => {
  return business.post(
    "",
    buildMutationEntityPayload("business", params, BUSINESS_MUTATION_FIELDS)
  );
};

export const updateBusiness = (params) => {
  return business.patch(
    `/${params.id}`,
    buildMutationEntityPayload("business", params, BUSINESS_MUTATION_FIELDS)
  );
};

export const generateCSVBusiness = () => {
  return business.post("/export", {});
};

export const getClientBusiness = (params) => {
  return business.post(
    "/by-client",
    buildEntityPayload("business", {
      id: params?.id,
    })
  );
};

export const getBusinessByClient = (params) => {
  return business.post(
    "/by-client/query",
    buildPaginatedEntityPayload("business", params, {
      clientId: params?.clientId,
    })
  );
};

export const webScript = (params) => {
  return business.post(`/${params}/widget-script`);
};

export const webScriptV2 = (params) => {
  return business.post(`/${params}/widget-script-variants`);
};

export const getWidgetScriptSettings = () => {
  return business.post("/widget-settings/query", {});
};

export const updateWidgetScriptSettings = (params) => {
  return business.patch("/widget-settings", {
      business: {
        widgetStagingBundleUrl: params.widgetStagingBundleUrl,
        widgetProdBundleUrl: params.widgetProdBundleUrl,
        widgetLegacyBundleUrl: params.widgetLegacyBundleUrl,
        stagingBundleUrl: params.widgetStagingBundleUrl,
        prodBundleUrl: params.widgetProdBundleUrl,
        legacyBundleUrl: params.widgetLegacyBundleUrl,
      },
  });
};

export const getBusinessForBusiness = (params) => {
  return business.post(
    "/by-login",
    buildEntityPayload("business", {
      businessId: params?.businessId,
    })
  );
};

export const getPhorestIntegration = (businessId) => {
  return business.get(`/${businessId}/integrations/phorest`);
};

export const updatePhorestIntegration = (businessId, integration) => {
  return business.put(`/${businessId}/integrations/phorest`, integration);
};

export const getMessengerIntegration = (businessId) => {
  return business.get(`/${businessId}/integrations/messenger`);
};

export const updateMessengerIntegration = (businessId, integration) => {
  return business.put(`/${businessId}/integrations/messenger`, integration);
};
